import { DeviceTheme, GetMysteryShopperDto, SaveBasicInformationDto } from '../../api/api.g';
import { UserPreferencesState } from '../../store/userPrefsSlice';

export class UserPrefsHelper {
  private static readonly SYSTEM_THEME_FALLBACK_VALUE = 2;

  private static getSystemThemeEnumValue(): DeviceTheme {
    return DeviceTheme.System;
  }

  private static isSystemThemePreference(themePreference?: UserPreferencesState['themePreference']): boolean {
    if (themePreference === undefined || themePreference === null) {
      return true;
    }

    return themePreference === DeviceTheme.System || Number(themePreference) === UserPrefsHelper.SYSTEM_THEME_FALLBACK_VALUE;
  }

  private static isSystemThemeFromApi(theme?: DeviceTheme): boolean {
    const systemEnumValue = UserPrefsHelper.getSystemThemeEnumValue();
    if (theme === undefined || theme === null) {
      return true;
    }

    if (theme === systemEnumValue) {
      return true;
    }

    return Number(theme) === UserPrefsHelper.SYSTEM_THEME_FALLBACK_VALUE;
  }

  public static mapToSaveBasicInformationDto(u: UserPreferencesState): SaveBasicInformationDto {
    const data = new SaveBasicInformationDto();
    const systemEnumValue = UserPrefsHelper.getSystemThemeEnumValue();
    const resolvedTheme = UserPrefsHelper.isSystemThemePreference(u.themePreference) ? systemEnumValue : u.themePreference;

    data.init({
      firstName: u.firstName,
      languages: u.languages,
      lastName: u.lastName,
      phoneNumber: u.phoneNumber,
      theme: resolvedTheme,
    });

    return data;
  }

  public static mapFromToDto<T>(u: SaveBasicInformationDto | GetMysteryShopperDto): T {
    const data = {
      firstName: u.firstName,
      languages: u.languages,
      lastName: u.lastName,
      phoneNumber: u.phoneNumber,
      theme: u.theme,
      themePreference: UserPrefsHelper.isSystemThemeFromApi(u.theme) ? DeviceTheme.System : u.theme,
      profiles: undefined,
      addresses: undefined,
      phoneNumberVerified: false
    };

    if (u instanceof GetMysteryShopperDto) {
      data.profiles = u.profiles;
      data.addresses = u.addresses;
      data.phoneNumberVerified = u.verified;
    }

    return data as T;
  }
}
